(function(){
  'use strict';

  var CATEGORY_LINKS={
    'tapware-1':[
      ['Basin Mixers','/collections/basin-mixers'],['Kitchen Taps','/collections/kitchen-taps'],['Shower Tapware','/collections/shower-tapware'],['Spouts','/collections/spouts-1']
    ],
    'showers-1':[
      ['Shower Sets','/collections/shower-sets'],['Hand Showers','/collections/hand-showers-1'],['Shower Heads','/collections/shower-heads'],['Shower Arms','/collections/shower-arms']
    ],
    'basins-1':[
      ['Countertop Basins','/collections/countertop-basins-1'],['Undermount Basins','/collections/undermount-basins']
    ],
    'baths':[
      ['1300mm Baths','/collections/1300mm-bathtub'],['1500mm Baths','/collections/1500mm-bathtub'],['1700mm Baths','/collections/1700mm-bathtub'],['Matte White','/collections/matte-white-bathtub'],['Gloss White','/collections/gloss-white-bathtub']
    ],
    'toilet':[
      ['Toilet Pans','/collections/toilet-pan'],['Back-to-Wall Toilets','/collections/toilet-back-to-wall'],['Cisterns','/collections/toilet-cistern'],['Toilet Packages','/collections/toilet-package'],['Buttons & Flush Plates','/collections/toilet-buttons']
    ],
    'vanity':[
      ['Shaving Cabinets','/collections/shaving-cabinets'],['Fluted Vanities','/collections/fluted-vanities'],['PVC Vanities','/collections/pvc-vanities'],['Bondi','/collections/bondi-vanity'],['Byron','/collections/byron-vanity'],['Laguna','/collections/laguna-vanity'],['Space Saver','/collections/space-saver-vanity']
    ],
    'sinks-1':[
      ['Stainless Steel Sinks','/collections/stainless-steel-sinks'],['Granite Sinks','/collections/granite-sinks'],['Laundry Sinks','/collections/laundry-sinks-1'],['Washing Machine Stops','/collections/washing-machine-stops-2']
    ],
    'mirrors-1':[
      ['LED Mirrors','/collections/led-mirrors'],['Standard Mirrors','/collections/standard-mirrors']
    ],
    'accessories':[
      ['Towel Rails','/collections/towel-rails-auto'],['Robe Hooks','/collections/robe-hooks'],['Paper Holders','/collections/paper-holders'],['Shelves','/collections/shelves'],['Soap Dishes','/collections/soap-dishes'],['Floor Wastes','/collections/floor-wastes'],['Bottle Traps','/collections/bottle-traps'],['Pop-Up Wastes','/collections/pop-up-wastes']
    ],
    'handles':[
      ['Vanity Handles','/collections/vanity-handles']
    ]
  };

  function normalise(value){
    return String(value||'').toLowerCase().replace(/\s+/g,' ').trim();
  }

  function splitKeywords(value){
    return normalise(value).split(',').map(function(keyword){return keyword.trim();}).filter(Boolean);
  }

  function collectionHandle(){
    var match=location.pathname.match(/^\/collections\/([^/?#]+)/);
    return match?decodeURIComponent(match[1]):'';
  }

  function correctLabels(scope){
    (scope||document).querySelectorAll('.nv-vc-filter-label').forEach(function(label){
      if(/^(acessories|accesories|accessories)$/i.test(label.textContent.trim())) label.textContent='Accessories';
    });
  }

  function productPath(card){
    var link=card.querySelector('a[href*="/products/"]');
    var url=card.getAttribute('data-product-url')||(link?link.getAttribute('href'):'')||'';
    try{return new URL(url,location.origin).pathname;}catch(error){return url.split('?')[0];}
  }

  function staticTokens(card){
    return [
      card.getAttribute('data-filter-tokens'),
      card.getAttribute('data-variant-title'),
      card.getAttribute('data-product-title'),
      card.getAttribute('data-product-url'),
      card.textContent
    ].filter(Boolean).join(' | ');
  }

  function seedCard(card){
    if(!card.hasAttribute('data-nuvio-filter-tokens')){
      card.setAttribute('data-nuvio-filter-tokens',normalise(staticTokens(card)));
    }
  }

  var productCache={};
  function enrichCard(card){
    seedCard(card);
    if(card.getAttribute('data-nuvio-enriched')==='true') return Promise.resolve();
    var path=productPath(card);
    if(!path) return Promise.resolve();
    if(!productCache[path]){
      productCache[path]=fetch(path+'.js',{headers:{Accept:'application/json'}})
        .then(function(response){if(!response.ok) throw new Error('Product data unavailable');return response.json();})
        .then(function(product){
          var parts=[product.title,product.type,product.vendor,(product.tags||[]).join(' '),(product.options||[]).join(' ')];
          (product.variants||[]).forEach(function(variant){
            parts.push(variant.title);
            if(variant.options) parts.push(variant.options.join(' '));
          });
          return normalise(parts.join(' | '));
        })
        .catch(function(){return '';});
    }
    return productCache[path].then(function(extra){
      card.setAttribute('data-nuvio-filter-tokens',normalise(staticTokens(card)+' | '+extra));
      card.setAttribute('data-nuvio-enriched','true');
    });
  }

  function activeButton(root){
    return root.querySelector('.nv-vc-filter.is-active');
  }

  function activeValue(root){
    var active=activeButton(root);
    return active?(active.getAttribute('data-filter-value')||''):'';
  }

  function visibleCards(root){
    return Array.prototype.filter.call(root.querySelectorAll('.nv-vc-card'),function(card){
      return !card.classList.contains('is-hidden')&&card.hidden!==true;
    });
  }

  function ensureToolbar(root){
    var toolbar=root.querySelector('.nuvio-results-toolbar');
    if(toolbar) return toolbar;
    toolbar=document.createElement('div');
    toolbar.className='nuvio-results-toolbar';
    toolbar.innerHTML='<span data-nuvio-result-count aria-live="polite"></span><span class="nuvio-results-toolbar__active"><span class="nuvio-active-filter"><span data-nuvio-active-label></span><button type="button" class="nuvio-clear-filter" aria-label="Clear selected filter">×</button></span></span>';
    var grid=root.querySelector('.nv-vc-grid');
    if(grid) grid.parentNode.insertBefore(toolbar,grid);
    else root.appendChild(toolbar);
    toolbar.querySelector('.nuvio-clear-filter').addEventListener('click',function(){clearFilter(root);});
    return toolbar;
  }

  function updateToolbar(root){
    var toolbar=ensureToolbar(root);
    var count=visibleCards(root).length;
    var total=root.querySelectorAll('.nv-vc-card').length;
    var active=activeButton(root);
    toolbar.querySelector('[data-nuvio-result-count]').textContent=count+' '+(count===1?'product':'products')+(count!==total?' shown':'');
    var activeWrap=toolbar.querySelector('.nuvio-results-toolbar__active');
    if(active&&activeValue(root)){
      var labelElement=active.querySelector('.nv-vc-filter-label');
      var label=labelElement?labelElement.textContent.trim():active.textContent.trim();
      toolbar.querySelector('[data-nuvio-active-label]').textContent=label;
      activeWrap.classList.add('is-visible');
    }else{
      activeWrap.classList.remove('is-visible');
    }
  }

  function clearFilter(root){
    var buttons=root.querySelectorAll('.nv-vc-filter');
    var all=null;
    Array.prototype.forEach.call(buttons,function(button){
      if(!all&&!(button.getAttribute('data-filter-value')||'').trim()) all=button;
    });
    if(all){all.click();return;}
    root.querySelectorAll('.nv-vc-filter').forEach(function(button){button.classList.remove('is-active');});
    applyFilter(root,'');
  }

  function ensureEmptyReset(root,empty){
    if(!empty||empty.querySelector('.nuvio-empty-reset')) return;
    var message=empty.querySelector('p')||empty;
    if(message&&/no products/i.test(message.textContent||'')){
      message.textContent='No products match this filter yet. Clear the filter to view the full range.';
    }
    var button=document.createElement('button');
    button.type='button';
    button.className='nuvio-empty-reset';
    button.textContent='View all products';
    button.addEventListener('click',function(){clearFilter(root);});
    empty.appendChild(button);
  }

  function applyFilter(root,value){
    var keywords=splitKeywords(value);
    var typeControl=root.querySelector('[data-nv-filter-type]');
    var rangeControl=root.querySelector('[data-nv-filter-range]');
    var availabilityControl=root.querySelector('[data-nv-filter-availability]');
    var priceControl=root.querySelector('[data-nv-filter-price]');
    var typeValue=typeControl?normalise(typeControl.value):'';
    var rangeValue=rangeControl?normalise(rangeControl.value):'';
    var availabilityValue=availabilityControl?String(availabilityControl.value||''):'';
    var priceValue=priceControl?String(priceControl.value||''):'';
    var priceParts=priceValue?priceValue.split('-'):[];
    var priceMin=priceParts[0]?parseInt(priceParts[0],10):null;
    var priceMax=priceParts[1]?parseInt(priceParts[1],10):null;
    var hasAdvanced=!!(typeValue||rangeValue||availabilityValue||priceValue);
    var visible=0;

    root.querySelectorAll('.nv-vc-card').forEach(function(card){
      seedCard(card);
      var tokens=normalise(card.getAttribute('data-nuvio-filter-tokens'));
      var finishHit=!keywords.length||keywords.some(function(keyword){return tokens.indexOf(keyword)!==-1;});
      var productType=normalise(card.getAttribute('data-product-type'));
      var productTags=String(card.getAttribute('data-product-tags')||'').toLowerCase();
      var productAvailable=String(card.getAttribute('data-product-available')||'');
      var productPrice=parseInt(card.getAttribute('data-product-price')||'0',10);
      var typeHit=!typeValue||productType===typeValue;
      var rangeHit=!rangeValue||productTags.indexOf('|'+rangeValue+'|')!==-1;
      var availabilityHit=!availabilityValue||productAvailable===availabilityValue;
      var priceHit=!priceValue||
        ((priceMin===null||productPrice>=priceMin)&&(priceMax===null||productPrice<priceMax));
      var match=finishHit&&typeHit&&rangeHit&&availabilityHit&&priceHit;
      card.classList.toggle('is-hidden',!match);
      if(match) visible++;
    });
    var empty=root.querySelector('[data-liveempty],.nv-vc-empty');
    if(empty){
      empty.classList.toggle('is-visible',visible===0&&(keywords.length>0||hasAdvanced));
      ensureEmptyReset(root,empty);
    }
    updateToolbar(root);
  }

  function enrichAll(root){
    return Promise.all(Array.prototype.map.call(root.querySelectorAll('.nv-vc-card'),enrichCard));
  }

  function initCollection(root){
    if(root.dataset.nuvioUiReady==='true') return;
    root.dataset.nuvioUiReady='true';
    correctLabels(root);
    ensureToolbar(root);
    applyFilter(root,activeValue(root));
    enrichAll(root).then(function(){applyFilter(root,activeValue(root));});
    root.querySelectorAll('.nv-vc-filter').forEach(function(button){
      button.addEventListener('click',function(){
        setTimeout(function(){
          applyFilter(root,activeValue(root));
          enrichAll(root).then(function(){applyFilter(root,activeValue(root));});
        },0);
      });
    });
    var grid=root.querySelector('.nv-vc-grid');
    if(grid&&window.MutationObserver){
      new MutationObserver(function(){
        applyFilter(root,activeValue(root));
        enrichAll(root).then(function(){applyFilter(root,activeValue(root));});
      }).observe(grid,{childList:true,subtree:true});
    }
  }

  function addCategoryLinks(){
    if(document.querySelector('[data-nuvio-category-links]')) return;
    var handle=collectionHandle();
    var links=CATEGORY_LINKS[handle];
    if(!links||!links.length) return;
    var nav=document.createElement('nav');
    nav.className='nuvio-category-nav';
    nav.setAttribute('data-nuvio-category-links','');
    nav.setAttribute('aria-label','Shop this category');
    nav.innerHTML='<p class="nuvio-category-nav__eyebrow">Shop by category</p><div class="nuvio-category-nav__links"></div>';
    var list=nav.querySelector('.nuvio-category-nav__links');
    links.forEach(function(item){
      var link=document.createElement('a');
      link.className='nuvio-category-link';
      link.href=item[1];
      link.textContent=item[0];
      list.appendChild(link);
    });
    var custom=document.querySelector('.nuvio-variant-collection');
    if(custom){
      var header=custom.querySelector('.nv-vc-header');
      if(header&&header.parentNode) header.parentNode.insertBefore(nav,header.nextSibling);
      else custom.insertBefore(nav,custom.firstChild);
      return;
    }
    var target=document.querySelector('#ProductGridContainer,.collection,main');
    if(target) target.insertBefore(nav,target.firstChild);
  }

  function improveProductPage(){
    var quoteSection=document.querySelector('[id*="request_quote"],[id*="request-quote"],.request-quote');
    var anchor=document.getElementById('nuvio-request-quote');
    if(quoteSection&&!anchor){
      anchor=document.createElement('span');
      anchor.id='nuvio-request-quote';
      anchor.setAttribute('aria-hidden','true');
      quoteSection.parentNode.insertBefore(anchor,quoteSection);
    }
    var info=document.querySelector('.nuvio-purchase-info');
    if(info&&anchor){
      var quoteLink=info.querySelector('a[href="#nuvio-request-quote"]');
      if(quoteLink) quoteLink.addEventListener('click',function(event){
        event.preventDefault();
        anchor.scrollIntoView({behavior:'smooth',block:'start'});
      });
    }
  }

  function cleanStorefront(scope){
    var root=scope||document;
    root.querySelectorAll('a[href^="tel:+61450314331"],a[href^="tel:0450314331"]').forEach(function(anchor){
      anchor.href='tel:+61285308366';anchor.textContent='02 8530 8366';
    });
    root.querySelectorAll('option').forEach(function(option){if(/showroom visit/i.test(option.textContent||option.value)) option.remove();});
    root.querySelectorAll('.nv-cp-detail-label').forEach(function(element){if(/^showroom$/i.test(element.textContent.trim())) element.textContent='Address';});
    root.querySelectorAll('pickup-availability,.pickup-availability-wrapper,#Pickup-Availability,.side-availability').forEach(function(element){element.remove();});
    root.querySelectorAll('input[type="search"],input[name="q"]').forEach(function(input){
      if(/curation/i.test(input.placeholder||'')) input.placeholder='Search products, finishes or categories';
    });
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(node){
      var parent=node.parentNode&&node.parentNode.nodeName;
      return /^(SCRIPT|STYLE|TEXTAREA|OPTION)$/i.test(parent)?NodeFilter.FILTER_REJECT:NodeFilter.FILTER_ACCEPT;
    }});
    var nodes=[];while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      node.nodeValue=node.nodeValue
        .replace(/0450 314 331/g,'02 8530 8366')
        .replace(/PO Box 2772, Taren Point NSW 2229/gi,'12/29 Wurrook Circuit, Caringbah NSW 2229')
        .replace(/Designed in Australia/gi,'Affordable bathware. Honest prices.');
    });
    var redirects={
      '/collections/accesories':'/collections/accessories',
      '/collections/accesories-v2':'/collections/accessories',
      '/collections/kitchen-mixers':'/collections/kitchen-taps',
      '/collections/toilet-button':'/collections/toilet-buttons',
      '/pages/showroom':'/pages/contact-us',
      '/pages/contact':'/pages/contact-us'
    };
    root.querySelectorAll('a[href]').forEach(function(anchor){
      var path='';try{path=new URL(anchor.href,location.origin).pathname;}catch(error){}
      if(redirects[path]) anchor.href=redirects[path];
    });
  }

  function boot(scope){
    var root=scope||document;
    correctLabels(root);
    root.querySelectorAll('.nuvio-variant-collection').forEach(initCollection);
    cleanStorefront(root);
    addCategoryLinks();
    improveProductPage();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();
